import Emitter from "es6-event-emitter";

import publicationList from "./../templates/publicationList.dust";

/**
 * Contstructs the Kiosque view
 */
export default class PublicationList extends Emitter {
  constructor(
    appState,
    DOMContent,
    name,
    titleName,
    contentPackages,
    clickedEvent,
    options
  ) {
    super();
    this.appState = appState;
    this.DOMContent = DOMContent;
    this.name = name;
    this.titleName = titleName;
    this.contentPackages = contentPackages;
    this.clickedEvent = clickedEvent;
    this.options = options;
  }

  createContext() {
    const context = {};
    context.contentPackages = this.contentPackages;
    context.name = this.name;
    context.titleName = this.titleName;
    return context;
  }

  /**
   * Functions that inserts the publication list into the DOM
   * @returns {Promise} result of rendering
   */
  render() {
    if (this.DOMContent) {
      if (this.contentPackages && this.contentPackages.length === 0) {
        return Promise.resolve();
      }
      return new Promise((_, reject) => {
        const container = this._getPublicationListContainer();
        if (!container) {
          reject();
          return;
        }

        Dust.render(publicationList, this.createContext(), (err, result) => {
          container.innerHTML = result;
          this._attachPublicationClickListeners();
        });
      });
    } else {
      // FIXME The timeout existed before i wrapped the promise around it, please forgive me
      return new Promise((resolve) => {
        setTimeout(() => {
          this.render().then(() => resolve());
        }, 100);
      });
    }
  }

  _attachPublicationClickListeners() {
    const container = this._getPublicationListContainer();
    if (!container) {
      return;
    }

    const publicationDivs = container.querySelectorAll(
      "[data-contentpackageid]"
    );
    publicationDivs.forEach((div) => {
      div.addEventListener("click", (e) => {
        this.trigger("publicationList:onPublicationClicked", e);
        this.appState.triggerEvent(this.clickedEvent);
      });
    });
  }

  _getPublicationListContainer() {
    if (!this.DOMContent) {
      return undefined;
    }
    return this.DOMContent.querySelector(`#${this.name}`);
  }
}



// WEBPACK FOOTER //
// ./src/web/home/components/publicationList.js